import script from "./SegmentSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./SegmentSelect.vue?vue&type=script&setup=true&lang=ts"

import "./SegmentSelect.vue?vue&type=style&index=0&id=6756e025&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6756e025"]])

export default __exports__